export default __webpack_public_path__ + "static/media/recipe_app_erd.22cbdad5.png";